import {Component, OnInit, TemplateRef, ViewChild} from '@angular/core';
import {ProfileService} from '../../services/profile.service';
import {Meeting} from '../../model/meeting';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {CommonModule} from "@angular/common";
import {SearchBarComponent} from "../../components/common/search-bar/search-bar.component";
import {FaIconComponent} from "@fortawesome/angular-fontawesome";
import {SearchPipe} from "../../components/common/SearchPipe";
import {SortPipe} from "../../components/common/SortPipe";
import {PrestationCalendarComponent} from "../../components/user/prestation-calendar/prestation-calendar.component";
import {BreadcrumbComponent} from "../../components/common/breadcrumb/breadcrumb.component";
import {PlacePipe} from "../../components/common/PlacePipe";

@Component({
    selector: 'app-meetings',
    imports: [
        CommonModule,
        SearchBarComponent,
        FaIconComponent,
        SearchPipe,
        SortPipe,
        PrestationCalendarComponent,
        BreadcrumbComponent,
        PlacePipe,
    ],
    templateUrl: './meetings.component.html',
    styleUrls: ['./meetings.component.css']
})
export class MeetingsComponent implements OnInit {

  @ViewChild('viewMeeting') viewmeeting: TemplateRef<any>;

  search = '';
  meetings: Meeting[];
  meeting: Meeting;
  overMeeting;
  dates: Date[] = [];

  constructor(private profileService: ProfileService, private modalService: NgbModal) {
  }

  ngOnInit(): void {
    // Limit date is 4 months from now, back to first day (by setting date to 1), at 00:00
    const limitDate = new Date();
    limitDate.setMonth(limitDate.getMonth() + 4);
    limitDate.setDate(1);
    limitDate.setHours(0);
    limitDate.setMinutes(0);

    this.profileService.getProfile().subscribe(profile => {
      if (profile.meetings) {
        this.meetings = profile.meetings.filter(m => {
          return m.status === 'Planned' && new Date(m.dateStart) < limitDate;
        });
      }
    });
    for (let i = 0; i < 4; i++) {
      this.dates[i] = this.getNextDate(i);
    }
  }

  getNextDate(num: number): Date {
    const today = new Date();
    today.setMonth(today.getMonth() + num, 1);
    return today;
  }

  view(meet: Meeting): void {
    this.meeting = meet;
    this.modalService.open(this.viewmeeting, {size: 'lg'});
  }

}
